import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { buildGroupContextMoreInfoBlobProps } from 'components/common/group/GroupContextMoreInfoBlob';
import { GeneralRouteV2Id } from 'routes/routesConfigV2';
import PageInFlowNoSidebarLayout from 'components/common/general/layouts/PageInFlowNoSidebarLayout';
import DefaultInitiateProposalPageStore, {
  DefaultInitiateProposalPageStoreContext,
  useDefaultInitiateProposalPageStore,
} from 'store/pages/initiate-quote/initiate-proposal/default/pageStore';
import { useParams } from 'react-router-dom';
import DefaultInitiateProposalForm from 'components/common/initiate-proposal/Default';

const PageContent: React.FC = observer(() => {
  const {
    initiateQuoteFlowDelegate: { isInitialDataLoading, groupInfoDelegate, isFlowDataLoading },
    isActionLoading,
    canCompleteStep,
    proposalFormDelegate,
    domainParams: { groupId },
    getInitialData,
    saveProposal,
  } = useDefaultInitiateProposalPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  const moreInfoBlob = groupInfoDelegate.moreInfoBlobInput
    ? buildGroupContextMoreInfoBlobProps(groupInfoDelegate.moreInfoBlobInput)
    : undefined;

  return (
    <PageInFlowNoSidebarLayout
      contentWidth="standard"
      domainParams={{ groupId }}
      pageId={GeneralRouteV2Id.INITIATE_PROPOSAL}
      pageHeader={{ subtitleMaxWidth: '46rem' }}
      isInitialLoading={isInitialDataLoading}
      isInfoSectionLoading={isFlowDataLoading}
      isActionLoading={isActionLoading}
      moreInfoBlob={moreInfoBlob}
      pageFooter={{
        onComplete: saveProposal,
        disableCompleteButton: !canCompleteStep,
      }}
    >
      <DefaultInitiateProposalForm proposalFormDelegate={proposalFormDelegate} />
    </PageInFlowNoSidebarLayout>
  );
});

const DefaultInitiateProposalPage: React.FC = () => {
  const { groupId } = useParams<{ groupId: string }>();

  const pageStore = useMemo(() => new DefaultInitiateProposalPageStore({ groupId }), [groupId]);

  return (
    <DefaultInitiateProposalPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </DefaultInitiateProposalPageStoreContext.Provider>
  );
};

export default DefaultInitiateProposalPage;
